<template>
    <el-tabs type="border-card" v-model="currentTabName" class="menu-choose-box" @tab-click="handleTabClick" style="padding: 0">
        <el-tab-pane v-for="menu in menus" v-bind:key="menu.code" :label="menu.name" :name="menu.code" :style="{height: height ? height : 'auto'}"
                     style="overflow-y: scroll;padding: 15px">

            <el-tree

                    :default-expand-all="true"
                    :check-strictly="true"
                    @check-change="handleCheckChange"
                    :default-checked-keys="checkMenuItemCodes"
                    :data="menu.tree"
                    show-checkbox
                    node-key="code"
                    :props="defaultProps">
            </el-tree>

            <input type="hidden" v-model="value">

        </el-tab-pane>
    </el-tabs>
</template>

<script>
    export default {
        name: "MenuChooseBox",
        props:{
            value: {
                type: Array,
                default:function () {
                    return [] ;
                }
            },
            height: {
                type: String,
                default:''
            },
        },
        data() {
            return {
                menus: [],
                currentTabName: '',
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                checkMenuItemCodes: [],
            }
        },
        watch:{

            value(n,o){

                if(!o.length && n.length){
                    this.checkMenuItemCodes = this.value;

                }


            },

            checkMenuItemCodes:{
                deep:true,
                handler:function (e) {
                    this.$emit('input',e);
                }
            }
        },
        methods: {

            handleCheckChange(e, check) {

                let vm = this;

                if (check) {

                    if (this.checkMenuItemCodes.indexOf(e.code) === -1) {
                        vm.checkMenuItemCodes.push(e.code);
                    }

                } else {

                    if (this.checkMenuItemCodes.indexOf(e.code) !== -1) {
                        vm.checkMenuItemCodes.splice(this.checkMenuItemCodes.indexOf(e.code),1);
                    }

                }
            },

            handleTabClick(tab) {


                let vm = this;

                let menu = vm.menus.find((m) => {
                    return m.code === tab.name
                });


                if (menu && !menu.tree) {

                    vm.$http.post(vm.$api.menu.tree, vm.$qs.stringify({code: tab.name})).then((resp) => {
                        vm.$set(menu, 'tree', resp.data.data.menuItems);
                    });

                }
            }
        },
        created() {

            let vm = this;

            //加载菜单数据
            vm.$http.post(vm.$api.menu.list, vm.$qs.stringify({onPage: false})).then((resp) => {
                vm.menus = resp.data.data.menus;


                //加载第一个菜单项
                vm.$http.post(vm.$api.menu.tree, vm.$qs.stringify({code: vm.menus[0].code})).then((resp) => {
                    vm.$set(vm.menus[0], 'tree', resp.data.data.menuItems);
                    vm.currentTabName = vm.menus[0].code;
                });

            })


        }
    }
</script>

<style lang="scss" scoped>

    .el-tabs--border-card {
        box-shadow: none;
    }


</style>

<style lang="scss">

    .menu-choose-box {


        .el-tabs__header {
            background-color: #ffffff;

        }

        .el-tabs__content{
            padding: 0 !important;
        }

    }

</style>